import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Button,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    DragDropContext,
    Droppable,
    Draggable
} from "@hello-pangea/dnd";
import { IoClose } from "react-icons/io5";

import "../../../css/Administrador/FuncionesGenerales.css"
import { useUserAdmin } from "../../../admin/UserContext";
import { CrearProductos } from "./CrearProductos";
import { EditarProducto } from "./SetProducctoEditar/Editar";

export const ProductosAdmin = () => {
    const { Token } = useUserAdmin();
    const [sliders, setSliders] = useState([]);
    const [cateogria, setCategoria] = useState([]);
    const [ModalCrear, setModalCrear] = useState(false)
    const [SliderSelecion, setSliderSelecion] = useState([])
    const [ModalEditar, setModalEditar] = useState(false)

    const backendURL = process.env.REACT_APP_BACKEND_URL;


    const handleAbrirCrearSlider = () => {
        setModalCrear(true);
    };

    const fetchSliders = useCallback(async () => {
    try {
      const response = await axios.get(`${backendURL}/api/producto/categoria`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });
      setSliders(response.data.data);
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    }
  }, [Token, backendURL]);

  // Llamada inicial a sliders cuando hay token
  useEffect(() => {
    if (Token) {
      fetchSliders();
    }
  }, [Token, fetchSliders]);
   
    useEffect(() => {
        const fetchCategoria = async () => {
            try {
                const response = await axios.get(`${backendURL}/api/all/producto/home`, {
                    headers: {
                        Authorization: `Bearer ${Token}`,
                    },
                });
                setCategoria(response.data.data);
            } catch (error) {
                console.error("Error al obtener categorías:", error); // Corregido mensaje
            }
        };

        if (Token) {
            fetchCategoria();
        }
    }, [Token, backendURL]);

    const getCategoriaTitulo = (id) => {
        const cat = cateogria.find((c) => c.id === parseInt(id));
        return cat ? `${cat.titulo}${cat.titulo1 ? ' ' + cat.titulo1 : ''}` : `Categoría ${id}`;
    };
    const handleDelete = async (id) => {
        if (window.confirm('¿Estás seguro de que deseas eliminar este banner?')) {
            try {
                await axios.delete(`${backendURL}/api/productos/eliminar/${id}`, {
                    headers: {
                        Authorization: `Bearer ${Token}`
                    }
                });

                fetchSliders();
            } catch (error) {
                console.error("Error al eliminar el banner:", error);
                alert("Ocurrió un error al eliminar el banner.");
            }
        }
    };

    const handleAbrirModalEditar = (id) => {
        setSliderSelecion(id)
        setModalEditar(true);
    };
    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom sx={{ color: "#585857", fontWeight: 600 }}>
                Productos
            </Typography>

            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleAbrirCrearSlider}
                sx={{
                    color: "#fff",
                    background: "#5E487B",
                    textTransform: "capitalize",
                    marginTop: "20px",
                    marginBottom: "30px"
                }}
            >
                Crear nueva producto
            </Button>
            {Object.entries(sliders).map(([categoriaId, productos]) => (
                <Box key={categoriaId} sx={{ marginBottom: 4 }}>


                    <TableContainer
                        component={Paper}
                        sx={{
                            background: '#b2dfdb',
                            maxHeight: 400, // o el alto que necesites
                            overflowY: 'auto'
                        }}>
                        {sliders.length === 0 ? (
                            <Box p={3} textAlign="center" >
                                <Typography variant="subtitle1" sx={{ color: "#888" }}>
                                    No hay sliders agregados.
                                </Typography>
                            </Box>
                        ) : (
                            <DragDropContext>
                                <Droppable droppableId="slider-table">
                                    {(provided) => (
                                        <Table {...provided.droppableProps} stickyHeader ref={provided.innerRef} sx={{ color: '#585857' }}>
                                            <TableHead sx={{ backgroundColor: '#80cbc4' }}>
                                                <TableRow>
                                                    <TableCell sx={{ color: '#585857' }}>Categoria</TableCell>
                                                    <TableCell sx={{ color: '#585857' }}>tipo producto</TableCell>
                                                    <TableCell sx={{ color: '#585857' }}>Imagen producto</TableCell>
                                                    <TableCell sx={{ color: '#585857' }}>Titulo maquina</TableCell>
                                                    <TableCell sx={{ color: '#585857' }}>Acciones</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {productos.map((slider, index) => (
                                                    <Draggable key={slider.id} draggableId={slider.id.toString()} index={index}>
                                                        {(provided, snapshot) => (
                                                            <TableRow
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                sx={{
                                                                    background: snapshot.isDragging ? "#e0e0e0" : "#b2dfdb",
                                                                    cursor: "grab",

                                                                }}
                                                            >
                                                                <TableCell sx={{ color: '#585857', textTransform: 'UPPERCASE' }}> {getCategoriaTitulo(categoriaId)}  <div style={{
                                                                    width: '80px',
                                                                    height: '80px',
                                                                    backgroundColor: slider.color,
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: '50px'
                                                                }}></div> </TableCell>
                                                                <TableCell sx={{ color: '#585857' }}>{slider.tipo_producto} </TableCell>

                                                                <TableCell>
                                                                    {slider.imagen_producto && (
                                                                        <img
                                                                            src={`${backendURL}/${slider.imagen_producto}`}
                                                                            alt="Fondo"
                                                                            style={{ width: "80px", height: "auto", borderRadius: 4 }}
                                                                        />
                                                                    )}
                                                                </TableCell>



                                                                <TableCell sx={{ color: '#585857', fontWeight: '500' }}>
                                                                    {slider.titulo_maquina}  {slider.nombre_maquina}
                                                                </TableCell>

                                                                <TableCell>
                                                                    <Button
                                                                        size="small"

                                                                        onClick={() => handleAbrirModalEditar(slider.id)}
                                                                        startIcon={<EditIcon />}
                                                                        sx={{ marginRight: 1, background: '#ffcc80', color: '#fff', textTransform: "capitalize" }}
                                                                    >
                                                                        Editar
                                                                    </Button>
                                                                    <Button
                                                                        size="small"
                                                                        onClick={() => handleDelete(slider.id)}
                                                                        startIcon={<DeleteIcon />}
                                                                        sx={{ marginRight: 1, background: '#b71c1c', color: '#fff', textTransform: "capitalize" }}
                                                                    >
                                                                        Eliminar
                                                                    </Button>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </TableBody>
                                        </Table>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        )}
                    </TableContainer>
                </Box>
            ))}

            {/* modal crear slider */}
            <Modal open={ModalCrear} onClose={() => setModalCrear(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 900,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <section className="closemodal" onClick={() => setModalCrear(false)}>
                        <IoClose />
                    </section>
                    <CrearProductos fetchSliders={fetchSliders} onclose={() => setModalCrear(false)} />

                </Box>
            </Modal>
            {/* Modal editar */}
            <Modal open={ModalEditar} onClose={() => setModalEditar(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 700,
                        bgcolor: '#fff',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        maxHeight: '90vh',
                        overflowY: 'auto',
                    }}
                >
                    <section className="closemodal" onClick={() => setModalEditar(false)}>
                        <IoClose />
                    </section>
                    <EditarProducto fetchSliders={fetchSliders} slider={SliderSelecion} onclose={() => setModalEditar(false)} />

                </Box>
            </Modal>
        </Box>
    );
};